import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-primary-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-background-50 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-background-50 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            数据见证实力
          </h2>
          <p className="text-primary-100 text-sm md:text-base max-w-xl mx-auto">
            开云足球以卓越的技术实力和优质的服务体验，赢得数百万用户的信赖
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-2xl bg-background-50/20 text-background-50 mb-4">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </div>
              <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-2">
                {stat.value}
              </p>
              <p className="text-primary-100 text-sm md:text-base font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}